'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner, ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'transparent',
          // Sonner applies a default tinted border per-variant (success/error/warning/info)
          // that reads as a faint white halo on top of our solid bg colors. Force all
          // variants borderless so theraToast's !bg-* classes are the only chrome shown.
          '--success-border': 'transparent',
          '--error-border': 'transparent',
          '--warning-border': 'transparent',
          '--info-border': 'transparent',
          '--width': '420px',
        } as React.CSSProperties
      }
      toastOptions={{
        style: {
          width: 'fit-content',
          maxWidth: '420px',
          left: 0,
          right: 0,
          marginInline: 'auto',
          wordBreak: 'break-word',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
